exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".slide[data-v-23b32b24] {\n  background-size: cover;\n  background-position: center;\n  height: 100%;\n}\n.title-wrapper[data-v-23b32b24] {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n}\n.title[data-v-23b32b24] {\n  padding: 1em;\n  opacity: 0.8;\n}\n.carousel-100[data-v-23b32b24] .v-window-item {\n  height: 100%;\n}\n", ""]);

